export default __webpack_public_path__ + "static/media/NotoSans-latinext.b346d4a3.woff2";